<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :class="tableClass"
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: this.$t('Rodyti po:'),
        itemsPerPageAllText: this.$t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #[`item.bus_busena_buvusi`]="{ item }">
        <el-hipoteka-busena :busena="item.bus_busena_buvusi" />
      </template>
      <template #[`item.bus_busena_nauja`]="{ item }">
        <el-hipoteka-busena :busena="item.bus_busena_nauja" />
      </template>
      <template #[`item.bus_priezastis_aprasymas`]="{ item }">
        <template v-if="item.bus_busena_nauja === 'grazintas'">
          <div class="nowrap">
            <span class="byla-title">{{ $t('Grąžinti dokumentai:') }} </span>
            <el-byla
              v-for="byla in item.bylos"
              :key="byla.byl_id"
              :byla="byla"
              color="primary"
              in-line
              :class="byla.class"
            />
          </div>
          <span class="byla-title">{{ $t('Sprendimo motyvas:') }} </span><br />
          {{ item.bus_priezastis_aprasymas }}
        </template>
        <template v-if="item.bus_busena_nauja !== 'grazintas'">
          {{ item.bus_priezastis_aprasymas }}
        </template>
      </template>
      <template slot="loading">
        {{ $t('Kraunasi...') }}
      </template>
      <template slot="no-results">
        {{ $t('Duomenų nėra') }}
      </template>
      <template slot="no-data">
        {{ $t('Duomenų nėra') }}
      </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PrasymasIstorijaBusena',
  data() {
    return {
      loading: true,
      search: null,
      istorija: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  props: {
    praId: Number,
    minimal: Boolean,
  },
  computed: {
    ...mapGetters(['prasymasID', 'appSavitarna']),
    headers() {
      return [
        {
          text: this.$t('Buvusi būsena'),
          align: 'start',
          value: 'bus_busena_buvusi',
        },
        {
          text: this.$t('Nauja būsena'),
          align: 'start',
          value: 'bus_busena_nauja',
        },
        {
          text: this.$t('Sprendimo motyvai'),
          align: 'start',
          value: 'bus_priezastis_aprasymas',
          hide: this.isSavitarna,
        },
        {
          text: this.$t('Sprendimą pagrindžiančios teisės normos'),
          align: 'start',
          value: 'bus_priezastis_pagrindas',
          hide: this.isSavitarna,
        },
        {
          text: this.$t('Būsenos data'),
          align: 'start',
          value: 'bus_sukurimo_data',
        },
        {
          text: this.$t('Naudotojas'),
          align: 'start',
          value: 'bus_sukure',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.istorija.map(item => {
        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
          }
        })
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSavitarna() {
      return this.appSavitarna
    },
    isMinimal() {
      return this.praId > 0 || this.minimal
    },
    tableClass() {
      return this.isMinimal ? 'prasymas-miniTable' : ''
    },
    comPrasymasID() {
      return this.praId ?? this.prasymasID
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.comPrasymasID}/busenuistorija`)
        .then(res => {
          this.istorija = res.data.objektas
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.byla-title {
  font-weight: 600;
}
</style>
